import type { CSSProperties } from "react";

import type { BunkerRoute } from "../lib/bunkerGeometry";

interface BunkerConnectivityProps {
  routes: BunkerRoute[];
}

export function BunkerConnectivity({ routes }: BunkerConnectivityProps) {
  return (
    <div className="bunker-connectivity" data-route-count={routes.length} aria-hidden="true">
      {routes.map((route) => (
        <div
          className={`bunker-route route-${route.kind} passage-${route.state} ${route.sharedWall ? "route-shared-wall" : ""}`}
          data-connection-id={route.id}
          data-passage-state={route.state}
          data-route-kind={route.kind}
          key={route.id}
        >
          {route.segments.map((segment) => {
            const style = {
              "--passage-left": `${segment.left}%`,
              "--passage-top": `${segment.top}%`,
              "--passage-length": `${segment.length}%`,
              "--passage-order": segment.order,
            } as CSSProperties;
            return (
              <span
                className={`passage-segment passage-${segment.axis} ${segment.sharedWall ? "passage-shared-wall" : ""}`}
                data-axis={segment.axis}
                data-shared-wall={segment.sharedWall ? "true" : "false"}
                key={segment.id}
                style={style}
              >
                <i className="passage-lining" />
                <i className="passage-core" />
                <i className="passage-utility passage-power" />
                <i className="passage-utility passage-vent" />
                <i className="passage-lamps" />
              </span>
            );
          })}
          {(route.bends ?? (route.bend ? [route.bend] : [])).map((bend, index) => (
            <i
              className="passage-junction"
              key={`${route.id}-bend-${index}`}
              style={{
                "--junction-x": `${bend.x}%`,
                "--junction-y": `${bend.y}%`,
              } as CSSProperties}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
